import { motion, useReducedMotion } from "framer-motion";

const R = {
  round: "50% 50% 50% 50% / 50% 50% 50% 50%",
  a: "46% 54% 52% 48% / 53% 47% 53% 47%",
  b: "55% 45% 42% 58% / 45% 58% 42% 55%",
  c: "40% 60% 58% 42% / 60% 40% 60% 40%",
};

const STATES = {
  idle: { animate: { borderRadius: [R.round, R.a, R.round], scale: [1, 1.025, 1] }, t: { duration: 7, repeat: Infinity, ease: "easeInOut" } },
  listening: { animate: { borderRadius: [R.round, R.a, R.round], scale: [1, 1.07, 1] }, t: { duration: 1.4, repeat: Infinity, ease: "easeInOut" } },
  thinking: { animate: { borderRadius: [R.a, R.b, R.c, R.a], rotate: [0, 120, 240, 360], scale: [0.97, 1.02, 0.97] }, t: { duration: 3.2, repeat: Infinity, ease: "linear" } },
  speaking: { animate: { borderRadius: [R.round, R.b, R.a, R.round], scale: [1, 1.06, 0.98, 1.04, 1] }, t: { duration: 0.9, repeat: Infinity, ease: "easeInOut" } },
  executing: { animate: { borderRadius: [R.round, R.c, R.round], scaleX: [1, 1.12, 1], scaleY: [1, 0.92, 1] }, t: { duration: 2.2, repeat: Infinity, ease: "easeInOut" } },
  waiting: { animate: { borderRadius: R.round, scale: [1, 1.015, 1] }, t: { duration: 2.6, repeat: Infinity, ease: "easeInOut" } },
  completed: { animate: { borderRadius: R.round, scale: [1.08, 1] }, t: { duration: 0.6, ease: "easeOut" } },
  failed: { animate: { borderRadius: R.c, x: [-6, 6, -3, 3, 0] }, t: { duration: 0.5 } },
};

export const STATE_LABEL = {
  idle: "At rest", listening: "Listening", thinking: "Thinking", speaking: "Speaking",
  executing: "Working on a task", waiting: "Awaiting your approval", completed: "Completed", failed: "Something failed",
};

export const Orb = ({ state = "idle", size = 260, testId = "feerd-presence" }) => {
  const reduce = useReducedMotion();
  const cfg = STATES[state] || STATES.idle;
  return (
    <div data-testid={testId} data-state={state} className="relative select-none" style={{ width: size, height: size * 1.25 }} aria-label={`Feerd is ${STATE_LABEL[state]}`} role="img">
      {state === "waiting" && (
        <motion.div className="absolute rounded-full border border-[#D8BFD8]/50" style={{ width: size * 1.18, height: size * 1.18, left: -size * 0.09, top: -size * 0.09 }}
          animate={reduce ? {} : { opacity: [0.2, 0.8, 0.2], scale: [0.98, 1.03, 0.98] }} transition={{ duration: 2.4, repeat: Infinity }} />
      )}
      {(state === "listening" || state === "speaking") && !reduce && (
        <motion.div className="absolute rounded-full border border-[#C0C0C0]/30" style={{ width: size, height: size }}
          animate={{ scale: [1, 1.5], opacity: [0.5, 0] }} transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }} />
      )}
      <motion.div key={state} className={`absolute orb-core overflow-hidden ${state === "failed" ? "orb-failed" : ""}`} style={{ width: size, height: size }}
        animate={reduce ? {} : cfg.animate} transition={cfg.t}>
        <motion.div className="absolute inset-0 orb-sheen" animate={reduce ? {} : { rotate: 360 }} transition={{ duration: state === "thinking" ? 4 : 18, repeat: Infinity, ease: "linear" }} />
      </motion.div>
      <div className="absolute orb-floor" style={{ width: size * 1.4, height: size * 0.22, left: -size * 0.2, top: size * 1.06 }} />
    </div>
  );
};
